// extracted by mini-css-extract-plugin
module.exports = {"page":"olnZ2","previous":"_1yZ96","first":"_2awwp","next":"_16hP5","last":"XuDgE","active":"_35UYy","activePage":"I6ie-","large":"_37FWw","arrow":"wpIDX","inner":"YnxW5"};